import { ResponseCode } from '@services/responseCode';

const formatResObject = (webStoreVo) => {
  const res = {
    code: ResponseCode.NO_ERROR,
    data: {
      webStoreVo,
    },
  };

  return res;
};

export default formatResObject;
